import { useEffect, useRef } from 'react';

/**
 * Tiempo real de la guardería: cuando algo cambia (entra o sale un niño, una anotación, el rol)
 * el servidor avisa «changed» y la pantalla vuelve a pedir lo suyo. Reintenta si se cae.
 */
export function useNurserySocket(churchId: string | null, onChange: () => void): void {
  const handler = useRef(onChange);
  handler.current = onChange;

  useEffect(() => {
    if (!churchId || typeof WebSocket === 'undefined') return;
    let ws: WebSocket | null = null;
    let retry = 0;
    let timer: ReturnType<typeof setTimeout> | undefined;
    let stopped = false;

    const connect = () => {
      ws = new WebSocket(`${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/api/nursery/ws`);
      ws.onopen = () => {
        // Al reconectar se pudo perder algo: se recarga.
        if (retry > 0) handler.current();
        retry = 0;
        ws?.send(JSON.stringify({ type: 'join', churchId }));
      };
      ws.onmessage = (event) => {
        try {
          if ((JSON.parse(String(event.data)) as { type: string }).type === 'changed') handler.current();
        } catch {
          // Mensaje no reconocido: se ignora.
        }
      };
      ws.onclose = () => {
        if (stopped) return;
        retry += 1;
        timer = setTimeout(connect, Math.min(30_000, 1000 * 2 ** Math.min(retry, 5)));
      };
    };
    connect();
    return () => {
      stopped = true;
      if (timer) clearTimeout(timer);
      ws?.close();
    };
  }, [churchId]);
}
